import { useMutation, useQuery, useSubscription } from '@apollo/client'
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CryptoJS from 'crypto-js';
import { GET_JOIN_PRESENTATION, GET_PARTICIPANT } from '../graphql/query'
import './style.css'
import { CHANGE_SLIDE } from '../graphql/subscription'
import { CREATE_ANSWER, JOIN_PRESENTATION } from '../graphql/mutation';

export default function Join() {
    const params = useParams()
    const navigate = useNavigate()
    const user = localStorage.getItem(`xand_${params?.id}_user`)

    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [answer, setAnswer] = useState(null)

    const { data, loading } = useQuery(GET_JOIN_PRESENTATION, {
        variables: {
            "code": parseInt(params?.id)
        },
        context:{
            headers: {
                Authorization: user
            }
        }
    })

    const subscription = useSubscription(CHANGE_SLIDE, {
        variables: {
            "code": parseInt(params?.id)
        },
        onData: (datas) => {
            setAnswer(null)
            const { activeSlide, status } = datas?.data?.data?.changeSlide
            datas.client.writeQuery({
                query: GET_JOIN_PRESENTATION,
                variables: {
                    "code": parseInt(params?.id)
                },
                data: {
                    getOnePresentation: {
                        ...data?.getOnePresentation,
                        status,
                        activeSlide
                    }
                }
            })
        }
    })

    const getSlide = () => {
        const slide = data?.getOnePresentation?.allSlides?.find((e) => e?._id === data?.getOnePresentation?.activeSlide)
        const elements = slide && slide?.elements ? JSON.parse(slide?.elements) : []

        if (elements?.find((e) => e?.type === "MCQ")) {
            return {
                ...slide,
                elements: elements?.find((e) => e?.type === "MCQ")
            }
        } else if (elements?.find((e) => e?.type === "Word Cloud")) {
            return {
                ...slide,
                elements: elements?.find((e) => e?.type === "Word Cloud")
            }
        } else if (elements?.find((e) => e?.type === "Q&A")) {
            return {
                ...slide,
                elements: elements?.find((e) => e?.type === "Q&A")
            }
        } else {
            return "Look Up"
        }
    }

    const [join, joining] = useMutation(JOIN_PRESENTATION)

    const onJoin = () => {
        if (name?.trim() && email) {
            join({
                variables: {
                    "name": name,
                    "email": email,
                    "code": parseInt(params?.id)
                }
            }).then((e) => {
                if (e?.data?.onJoin) {
                    localStorage.setItem(`xand_${params?.id}_user`, e?.data?.onJoin)
                    setTimeout(() => {
                        window.location.reload()
                    }, 1000);
                }
            }).catch((err) => {
                alert(err?.message)
            })
        }
    }

    const [answers, answering] = useMutation(CREATE_ANSWER,{
        refetchQueries:[
            {
                query: GET_PARTICIPANT,
                context: {
                    headers: {
                        Authorization: user
                    }
                }
            }
        ]
    })

    const onAnswer = () => {
        if (answer) {
            answers({
                context: {
                    headers: {
                        Authorization: user
                    }
                },
                variables: {
                    "answer": {
                        "answer": answer,
                        "presentId": data?.getOnePresentation?._id,
                        "slideId": getSlide()?._id,
                        "code": parseInt(params?.id)
                    }
                },
            }).then(() => {
                setAnswer(null)
            })
        }
    }

    const myAnswer = data?.getParticipant?.answers?.find((e)=> e?.slideId === data?.getOnePresentation?.activeSlide)

    if (loading) {
        return (
            <div className='Loading'>
                <div className='Loader' />
            </div>
        )
    } else if (data?.getOnePresentation?.status !== "Live") {
        return (
            <div className='Loading'>
                Waiting for host to start presenting
            </div>
        )
    } else if (!user) {
        return (
            <div className='Join'>
                <div className='Join_User'>
                    <form onClick={(e) => {
                        e.preventDefault()
                        onJoin()
                    }}>
                        <input value={email || ""} type='email' onChange={(e) => setEmail(e?.target?.value)} placeholder='Enter your email' />
                        <input value={name || ""} style={{marginTop:15}} onChange={(e) => setName(e?.target?.value)} placeholder='Enter your name' />
                        <div className='Join_User_Btn_Con'>
                            <button className='Join_User_Btn1'>{joining?.loading ? "Joining" : "Join"}</button>
                            <button onClick={()=>navigate('/')} className='Join_User_Btn2'>Cancel</button>
                        </div>
                    </form>
                </div>
                <div className='Join_Head'>
                    <div className='Join_Logo_Text'>XAND.app</div>
                </div>
            </div>
        )
    } else if (data?.getOnePresentation?.status === "Live") {
        return (
            <div className='Join'>
                {getSlide() === "Look Up" ?
                    <h2>Look Up</h2>
                    : myAnswer?
                        <>
                            <h2>Submitted</h2>
                            <h3>Your answer: <b>{myAnswer?.answer}</b></h3>
                        </>
                        :
                        getSlide()?.elements?.type === "MCQ" ?
                            <div className='Join_MCQ'>
                                <h2>{getSlide()?.elements?.title}</h2>
                                <div className='Join_MCQ_Opt_Con'>
                                    {getSlide()?.elements?.options?.map((itm, ind) => {
                                        return <div className={answer === itm ? 'Join_MCQ_Opt Join_MCQ_Opt_Select' : 'Join_MCQ_Opt'} onClick={() => setAnswer(itm)} key={ind}>{itm}</div>
                                    })}
                                </div>
                                <div className='Join_MCQ_Btn_Con'>
                                    {getSlide()?.elements?.max && getSlide()?.elements?.max > 1 ? <p>Max selection {getSlide()?.elements?.max}</p> : null}
                                    <button className='Join_User_Btn1' onClick={() => onAnswer()}>{answering?.loading ? "Submitting" : "Submit"}</button>
                                </div>
                            </div>
                            : getSlide()?.elements?.type === "Word Cloud" ?
                                <div className='Join_MCQ'>
                                    <h2>{getSlide()?.elements?.title}</h2>
                                    <input value={answer || ""} onChange={(e) => setAnswer(e?.target?.value)} placeholder='Enter your answer' />
                                    <div className='Join_MCQ_Btn_Con'>
                                        <button className='Join_User_Btn1' onClick={() => onAnswer()}>{answering?.loading ? "Submitting" : "Submit"}</button>
                                    </div>
                                </div>
                                : getSlide()?.elements?.type === "Q&A" ?
                                    <div className='Join_MCQ'>
                                        <h2>{getSlide()?.elements?.title}</h2>
                                        <input value={answer || ""} onChange={(e) => setAnswer(e?.target?.value)} placeholder='Enter your answer' />
                                        <div className='Join_MCQ_Btn_Con'>
                                            <button className='Join_User_Btn1' onClick={() => onAnswer()}>{answering?.loading ? "Submitting" : "Submit"}</button>
                                        </div>
                                    </div>
                                    : null
                }
                <div className='Join_Head'>
                    <div className='Join_Logo_Text'>XAND.app</div>
                    <div>{data?.getParticipant?.name}</div>
                </div>
            </div>
        )
    }
}

function decryptObject(encryptedText, encryptediv) {
    const value = "mI5GY73C5hVxDoHajJZx84eZ7GiJGwk4"
    // const iv = CryptoJS.enc.Base64.parse(encryptediv);
    const bytes = CryptoJS.AES.decrypt(encryptedText, value, { encryptediv });
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    const decryptedObject = JSON.parse(decryptedData);

    console.log(decryptedObject);

    return decryptedObject
}